export default function () {
  return {
    isBooting: true,
    canInteract: true,
    validPin: false,
    validAge: false,
    resetDialog: false,
    notification: null,
    language: 'is',
  };
}
